module.exports = __webpack_public_path__ + "static/media/Look-10.1f563190.png";